// @core/api/endpoints/document/delete_document_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/document';

/**
 * Delete template
 * Deletes a document template. Existing documents created from this template are not affected.
 */
export async function DeleteDocumentTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
